<!-- =========================================================================================
  File Name: userSettingSideBar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4> {{ $t('user.setting.title') }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- MAX LOGIN ATTEMPT -->
        <label>Max Daily Logins</label>
        <span>  &nbsp;
        <vs-button v-if="dataMaxDailyLogins" size="small" >{{dataMaxDailyLogins}}</vs-button>
        <vs-button v-else size="small" >N/A</vs-button>
        </span>&nbsp;<vs-button v-if="dataMaxDailyLogins>0" @click="removeLimitaction()" size="small" class="danger">Remove Limit</vs-button>
        <vs-slider :max="10" :min="1" v-model="dataMaxDailyLogins" />

<!--        <vs-slider max=10 min=5 v-model="dataMaxDailyLogins"/>-->


       <p v-if="statusCheck" style="color: red">{{statusMessage}}</p>
<vs-divider></vs-divider>
        <vs-button color="primary" type="filled" @click.stop="resetUserLogins(dataId)">{{ $t('user.setting.btn_increase_daily_login') }}
        </vs-button>
        <br>
        <br>
        <p>{{ $t('user.setting.note')}}</p>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" >{{ $t('common.submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('common.cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from "vue-select";
import {GET_USER_LOGIN_DETAILS, RESET_USER_LOGINS, UPDATE_USER_LOGINS,REMOVE_USER_SETTING} from "@/graphql";

export default {
  props: {
    isUserSettingSidebarActive: {
      type: Boolean,
      required: true,

    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data() {
    return {
      dataId: null,
      dataMaxDailyLogins: null,
      removeLimit:false,
      statusCheck: false,
      statusMessage: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isUserSettingSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const {id} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.initValues()
        this.getUserLoginCounterData(this.dataId)

      }
    }
  },
  computed: {

    isSidebarActiveLocal: {
      get() {
        return this.isUserSettingSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataMaxDailyLogins
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    resetUserLogins (id) {
      this.$apollo
        .mutate({
          mutation: RESET_USER_LOGINS,
          variables: {
            id: id,

          }
        })
        .then(response => {
          if (response.data.resetUserLogins.status == "SUCCESS") {
            this.successNotification()
             this.$emit('closeSidebar')
            this.$validator.reset()
             this.initValues()

          } else if (response.data.resetUserLogins.status == "NOT_FOUND") {
            this.failedNotification()
          }


        })
    },
    getUserLoginCounterData(id) {
      this.$apollo
        .mutate({
          mutation: GET_USER_LOGIN_DETAILS,
          variables: {
            id:  id
          },
        })
        .then(response => {

           if(response.data.getUserSettingData.status=='SUCCESS'){
             // console.log(response)
             this.dataMaxDailyLogins = response.data.getUserSettingData.daily_logins
             this.statusCheck=false
           }else if (response.data.getUserSettingData.status =='NO_STUDENT_ASSOCIATED') {
             this.statusMessage="Warning:This " + this.$t('user.alert_title') + " is not attached to any " + this.$t('student.titlesmall')
             this.statusCheck=true
           }else if (response.data.getUserSettingData.status =='NO_CAMERA_ASSOCIATED') {
             this.statusMessage = "Warning:Not any " + this.$t('student.titlesmall') + " associated with camera."
             this.statusCheck = true
           } else if (response.data.getUserSettingData.status == 'NO_LOCATION_ASSOCIATED') {
             this.statusMessage = "Warning: This camera is not attached to any location."
             this.statusCheck = true

           }

        })

    },
    initValues() {
      if (this.data.id) return
      this.dataId = null
      this.dataMaxDailyLogins = null
      this.removeLimit=false

    },
    removeLimitaction(){
      this.removeLimit=true
      this.dataMaxDailyLogins = 0
    },
    submitData() {
     if(this.removeLimit==true && this.dataMaxDailyLogins==0)
      {
        // alert(this.dataId)
           this.$apollo
           .mutate({
            mutation: REMOVE_USER_SETTING,
          variables: {
            id: this.dataId
          },
        })
        .then(response => {
          this.successNotificationUpdate()
           this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
      })
      }
      // if (this.dataMaxDailyLogins != 'N/A')
      else{
        this.$apollo
          .mutate({
            mutation: UPDATE_USER_LOGINS,
            variables: {
              id: this.dataId,
              max_logins: this.dataMaxDailyLogins
            }
          }).then(response => {
          if (response.data.updateUserLogins.status == "SUCCESS") {
            this.successNotificationUpdate()
          } else if (response.data.updateUserLogins.status == "UPDATED") {
            this.successNotificationUpdate()
          }
        })
      }
      //  else {
      //   this.NotAlloweddNotification()
      // }

    },
    successNotificationUpdate() {
      this.$vs.notify({
        title: 'Daily Logins',
        text: 'daily login numbers updated successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    successNotification() {
      this.$vs.notify({
        title: 'Reset Daily Logins',
        text: this.$t('user.alert_title') + ' number of logins have been reset for the day.',
        color: 'success',
        position: 'top-right'
      })
    },
    NotAlloweddNotification() {
      this.$vs.notify({
        title: 'Not Allowed',
        text: 'Only greater than 0 value allowed',
        color: 'danger',
        position: 'top-right'
      })
    },
    failedNotification() {
      this.$vs.notify({
        title: this.$t('user.alert_title') + ' Detail',
        text: 'User data not found!',
        color: 'danger',
        position: 'top-right'
      })
    },
    LoginLimiteNotification(message) {
      this.$vs.notify({
        title: "Setting Warning",
        text: message,
        color: 'danger',
        position: 'top-right'
      })
    },

  },
  created() {
    if(this.dataId !=null){

    }
  }

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
